import { useEffect } from 'react';
import { isEmpty } from 'lodash';
import {
  FilterRoute,
  FiltersPayload,
  getFilterByRoute,
  updateAppliedDateRange,
  updateFiltersByRoute,
  useAppSelector,
} from '@zonofi/zono-money-store';
import { useDispatch } from 'react-redux';
import { SORT_FILTERS } from '../components';
import { isAnyFilterSelected } from '../components/filter/helpers';
import { getDefaultDateRange } from '../helper';

export const useInitializeFilters = ({
  route,
  open,
}: {
  route: FilterRoute;
  open: boolean;
}) => {
  const dispatch = useDispatch();

  const { filters } = useAppSelector(getFilterByRoute(route));

  useEffect(() => {
    if (!open) return;
    const { sortOptions = {} } = filters;

    if (isEmpty(sortOptions)) {
      const staticSortOptions = SORT_FILTERS[route];
      // const staticListFilter = DEFINED_FILTERS[route];

      dispatch(
        updateFiltersByRoute({
          loading: false,
          route,
          filter: {
            sortOptions: staticSortOptions,
          },
        })
      );
    }

    const defaultDateRangeValue = getDefaultDateRange(route);
    dispatch(updateAppliedDateRange(defaultDateRangeValue));
  }, [open, route]);

  const onUpdateFilter = (filter: FiltersPayload) => {
    dispatch(updateFiltersByRoute({ route, filter }));
  };

  const hasSelectedFilters = isAnyFilterSelected(filters);

  return {
    filters,
    onUpdateFilter,
    hasSelectedFilters,
  };
};
